import React from 'react';
import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

const DocumentPreviewPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const stateParam = searchParams.get('state');
  const document = stateParam ? JSON.parse(decodeURIComponent(stateParam)).document : null;

  return (
    <Box sx={{ 
      width: '100vw',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      bgcolor: '#1a1a1a'
    }}>
      {/* 简洁的标题栏 */}
      <Box sx={{ 
        py: 1.5,
        px: 3,
        display: 'flex',
        alignItems: 'center',
        bgcolor: '#2d2d2d',
        borderBottom: '1px solid #404040'
      }}>
        <Typography 
          variant="subtitle1" 
          sx={{ 
            color: '#fff',
            fontSize: '0.9rem',
            fontWeight: 500,
            opacity: 0.9
          }}
        >
          {document?.name}
        </Typography>
      </Box>

      {/* PDF 预览区域 */}
      <Box sx={{ 
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2
      }}>
        <Box sx={{ 
          width: '100%',
          height: '100%',
          bgcolor: '#fff',
          borderRadius: 1,
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}>
          <iframe
            src={document?.url || `data:application/pdf;base64,${document?.content}`}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
            }}
            title="Document Preview"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DocumentPreviewPage; 